export enum UIMSceneEnum {
    Leaderboard,
    Lobby,
    Homepage,
    Store,
    Profile,
    Game
}
